/* eslint-disable @typescript-eslint/no-namespace */
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { DotScreenPass } from 'three/examples/jsm/postprocessing/DotScreenPass';
import { RenderPixelatedPass } from 'three/examples/jsm/postprocessing/RenderPixelatedPass.js';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';
import { extend, Object3DNode, useFrame, useThree } from '@react-three/fiber';
import { Color, Vector2 } from 'three';
import { useRef, useEffect } from 'react';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
import { AppAdvancedOutlinePass } from './advancedOutlinePass';

extend({
  RenderPass,
  EffectComposer,
  OutlinePass,
  DotScreenPass,
  RenderPixelatedPass,
  UnrealBloomPass,
});

declare global {
  namespace JSX {
    interface IntrinsicElements {
      //   outlinePass: Object3DNode<OutlinePass, typeof OutlinePass>;
      dotScreenPass: Object3DNode<DotScreenPass, typeof DotScreenPass>;
      renderPixelatedPass: Object3DNode<RenderPixelatedPass, typeof RenderPixelatedPass>;
      unrealBloomPass: Object3DNode<UnrealBloomPass, typeof UnrealBloomPass>;
    }
  }
}

// Uncomment the passes you want to use
export const ThreeEffects = () => {
  const { camera, gl, scene, size } = useThree();
  const composer = useRef<EffectComposer>();

  useEffect(() => {
    composer.current = new EffectComposer(gl);

    const renderPass = new RenderPass(scene, camera);
    renderPass.renderToScreen = false;
    composer.current.addPass(renderPass);

    // const pixelatedPass = new RenderPixelatedPass(1, scene, camera);
    // composer.current.addPass(pixelatedPass);

    // const bloomPass = new UnrealBloomPass(new Vector2(size.width, size.height), 1.5, 0.4, 0.85);
    // composer.current.addPass(bloomPass);

    // const dotScreenPass = new DotScreenPass(new Vector2(size.width, size.height), 0.5, 0.8);
    // composer.current.addPass(dotScreenPass);

    // const outlinePass = new OutlinePass(new Vector2(size.width, size.height), scene, camera);
    // outlinePass.edgeThickness = 1;
    // outlinePass.edgeStrength = 5;
    // outlinePass.renderToScreen = false;
    // outlinePass.selectedObjects = [scene];
    // outlinePass.visibleEdgeColor = new Color().setRGB(0, 0, 0);
    // outlinePass.hiddenEdgeColor = new Color().setRGB(0, 0, 0);
    // composer.current.addPass(outlinePass);

    const advancedOutlinePass = new AppAdvancedOutlinePass(
      new Vector2(size.width, size.height),
      scene,
      camera,
      new Color().setRGB(0, 0, 0),
    );
    composer.current.addPass(advancedOutlinePass);

    const fxaa = new ShaderPass(FXAAShader);
    fxaa.uniforms['resolution'].value.set(1 / size.width, 1 / size.height);
    fxaa.renderToScreen = true;

    composer.current.addPass(fxaa);

    // Resize the composer when the window size changes
    composer.current.setSize(size.width, size.height);
  }, [gl, scene, camera, size]);

  useFrame(() => {
    composer.current?.render();
  }, 1);

  return null;
};
